import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	specialOfferUrl: '',
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	financeDomain: 'AUDI.ES',
	enablePriceDisclaimer: true,
	useStaticPriceDateRemark: true,
	nextBestActions: [
		{
			icon: '',
			description: 'Solicitar oferta',
			labelText: 'Solicitar oferta ',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://formularios.audi.es/configurador/?lg=es&action=oferta&time=9999&utm_source=audies&utm_medium=web&utm_campaign={{audiCode}}&utm_content=btn_link',
		},
		{
			icon: 'test-drive',
			description: 'Prueba de conducción',
			labelText: 'Prueba de conducción',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://formularios.audi.es/configurador/?lg=es&action=testdrive&utm_source=audies&utm_medium=web&utm_campaign={{audiCode}}&utm_content=btn_link_test_drive',
		},
	],
	summaryFooterCta: {
		icon: 'dealer-request',
		description: 'Pide tu oferta',
		labelText: 'Pide tu oferta',
		target: '_blank',

		trackingName: 'request a trade-in appraisal',
		url: 'https://formularios.audi.es/configurador/?lg=es&action=oferta&time=9999&utm_source=audies&utm_medium=web&utm_campaign=audicode&utm_content=btn_negro',
	},
	useIframe: false,
};
